module.exports = __webpack_public_path__ + "img/rise.8c2f0029.png";